import axios from 'axios';

//Пример для проекта

const API = axios.create({
    baseURL: `https://cosmetic.urbanstore.uz/api/api`,
    withCredentials: true,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },

});

const HTTP = axios.create({
    baseURL: `https://cosmetic.urbanstore.uz/api`,
    withCredentials: true,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
});

//Пример для локальной настройки


//Конфиг для API
// const API = axios.create({
//     baseURL: `http://localhost:8000/api`,
//     withCredentials: true,
//     headers: {
//         'Accept': 'application/json',
//         'Content-Type': 'application/json',
//     },

// });

// //Конфиг для авторизаций и токенов
// const HTTP = axios.create({
//     baseURL: `http://localhost:8000`,
//     withCredentials: true,
//     headers: {
//         'Accept': 'application/json',
//         'Content-Type': 'application/json',
//     },
// });



export { API, HTTP }